/* tslint:disable */
import {
  Product,
  ProductUom,
  MoveQualityControl,
  StockLocation,
  StockProductionLot
} from '../index';

declare var Object: any;
export interface StockMoveInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "product_qty"?: number;
  "product_uom_qty"?: number;
  "product_id"?: number;
  "location_dest_id"?: number;
  "prodlot_id"?: number;
  "picking_id"?: number;
  "packages"?: number;
  "total_move_lines_packages"?: number;
  "quality_control_ids"?: Array<any>;
  "product_uom"?: number;
  "location_id"?: number;
  product?: Product;
  uom?: ProductUom;
  qualityControlIds?: MoveQualityControl[];
  location?: StockLocation;
  location_dest?: StockLocation;
  prodlot?: StockProductionLot;
}

export class StockMove implements StockMoveInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "product_qty": number;
  "product_uom_qty": number;
  "product_id": number;
  "location_dest_id": number;
  "prodlot_id": number;
  "picking_id": number;
  "packages": number;
  "total_move_lines_packages": number;
  "quality_control_ids": Array<any>;
  "product_uom": number;
  "location_id": number;
  product: Product;
  uom: ProductUom;
  qualityControlIds: MoveQualityControl[];
  location: StockLocation;
  location_dest: StockLocation;
  prodlot: StockProductionLot;
  constructor(data?: StockMoveInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockMove`.
   */
  public static getModelName() {
    return "StockMove";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockMove for dynamic purposes.
  **/
  public static factory(data: StockMoveInterface): StockMove{
    return new StockMove(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockMove',
      plural: 'StockMoves',
      path: 'StockMoves',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "product_qty": {
          name: 'product_qty',
          type: 'number'
        },
        "product_uom_qty": {
          name: 'product_uom_qty',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "location_dest_id": {
          name: 'location_dest_id',
          type: 'number'
        },
        "prodlot_id": {
          name: 'prodlot_id',
          type: 'number'
        },
        "picking_id": {
          name: 'picking_id',
          type: 'number'
        },
        "packages": {
          name: 'packages',
          type: 'number'
        },
        "total_move_lines_packages": {
          name: 'total_move_lines_packages',
          type: 'number'
        },
        "quality_control_ids": {
          name: 'quality_control_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "product_uom": {
          name: 'product_uom',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom',
          keyTo: 'id'
        },
        qualityControlIds: {
          name: 'qualityControlIds',
          type: 'MoveQualityControl[]',
          model: 'MoveQualityControl',
          relationType: 'referencesMany',
                  keyFrom: 'quality_control_ids',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        location_dest: {
          name: 'location_dest',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_dest_id',
          keyTo: 'id'
        },
        prodlot: {
          name: 'prodlot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'prodlot_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockMove.ts